import React from 'react'
import { Modal as BaseModal } from 'support/modals'
import { useRouter } from '@morningtrain/react-navigation'

function Modal (props, ref) {
  const router = useRouter()

  return <BaseModal ref={ref} closeIcon={router.url('img/icons/close.svg')} {...props} />
}

export default React.forwardRef(Modal)
